import Header from "../../Layout/Header";
import {
  availability,
  stripeurl,
  updateavailability,
} from "../../service/Mainservice";
import Profilemenu from "./Profilemenu";
import { useEffect, useState } from "react";
import "./Earning.css";
import Loader from "../../Loader/Loader";
import KYCPopup from "./KYC";
import { useNavigate } from "react-router-dom";
import { Alert, Snackbar } from "@mui/material";

const Availability = () => {
  const [data, setdata] = useState();
  const [load, setload] = useState(true);
  const [kyc, setkyc] = useState();
  const [url, seturl] = useState(false);
  const [error, seterror] = useState();
  const [error2, seterror2] = useState();
  const [open, setOpen] = useState(false);
  const [success, setsuccess] = useState();
  const [open2, setOpen2] = useState(false);
  const [weekAvailability, setWeekAvailability] = useState({
    MON: { start: "", end: "", fullday: "" },
    TUE: { start: "", end: "", fullday: "" },
    WED: { start: "", end: "", fullday: "" },
    THU: { start: "", end: "", fullday: "" },
    FRI: { start: "", end: "", fullday: "" },
    SAT: { start: "", end: "", fullday: "" },
    SUN: { start: "", end: "", fullday: "" },
  });

  useEffect(() => {
    getdata();
    checkstripe();
  }, []);

  const checkstripe = async () => {
    const response = await stripeurl();
    if (response.data.url) {
      seturl(response.data.url);
      setkyc(true);
    }
  };
  const daysMap = {
    MON: "mon",
    TUE: "tu",
    WED: "wed",
    THU: "th",
    FRI: "fr",
    SAT: "sa",
    SUN: "su",
  };

  const getdata = async () => {
    try {
      const response = await availability();
      console.log(response.data.data);
      const parsedWeekAvailability = Object.keys(daysMap).reduce(
        (acc, dayKey) => {
          const prefix = daysMap[dayKey]; // e.g., "mon"
          acc[dayKey] = {
            start: response.data.data[`${prefix}_s_time`] || "",
            end: response.data.data[`${prefix}_e_time`] || "",
            fullday: response.data.data[`${prefix}_day_selection`] || "",
          };
          return acc;
        },
        {}
      );

      setWeekAvailability(parsedWeekAvailability);
      setdata(response.data);
      setload(false);
    } catch (error) {
      console.log(error);
      setload(false);
    }
  };

  console.log("Week", weekAvailability);
  const [selectedDay, setSelectedDay] = useState("MON");

  const navigate = useNavigate();

  const isValid = Object.values(weekAvailability).some(
    (day) => day.start && day.end && day.fullday
  );

  useEffect(() => {
    isValid && seterror("");
  }, [weekAvailability]);

  const handleTimeChange = (e) => {
    const { name, value } = e.target;

    setWeekAvailability((prevAvailability) => ({
      ...prevAvailability,
      [selectedDay]: {
        ...prevAvailability[selectedDay],
        [name]: value,
      },
    }));
  };
  const handleFullDayChange = (e) => {
    setWeekAvailability((prevAvailability) => ({
      ...prevAvailability,
      [selectedDay]: {
        ...prevAvailability[selectedDay],
        fullday: e,
      },
    }));
  };

  const handleDayClick = (day) => {
    setSelectedDay(day);
  };

  const handlesubmit = async () => {
    if (!isValid) {
      seterror("Please set availability for at least one day.");
      return;
    }
    const invalidDay = Object.entries(weekAvailability).find(
      ([day, values]) =>
        (values.fullday === "half" || values.fullday === "full") &&
        (!values.start || !values.end)
    );

    console.log("Invalid", invalidDay);
    if (invalidDay) {
      seterror(
        `Please set From and To time for ${invalidDay[0]} when selecting Half/Full Day.`
      );
      return;
    }

    setload(true);
    try {
      const response = await updateavailability(weekAvailability);
      setload(false);
      setsuccess("Availability updated successfully");
      setOpen(true);
    } catch (error) {
      setload(false);
      seterror2(error.message);
      setOpen2(true);
    }
  };

  return (
    <>
      <Header title="Earning/Stubs" headerbg="earningbg" />
      <div className="editprofile_data">
        <Profilemenu />
        <div className="editprofile_info">
          <h2 className="editprofile_maintitle">Availability</h2>
          {/* <h2>Change Availability</h2> */}
          <p className="availability-note">
            Note: Select each day and choose whether you’re available{" "}
            <b>Full Day</b>, <b>Half Day</b>, or <b>Not Available</b>.
          </p>
          <div className="days">
            {Object.keys(weekAvailability).map((day) => (
              <p
                key={day}
                className={
                  selectedDay === day ? "daysname selectedday" : "daysname"
                }
                onClick={() => handleDayClick(day)}
              >
                {day}
              </p>
            ))}
          </div>

          <h5>Select Time For {selectedDay}</h5>
          <div className="Bookcaregiver_timslot">
            <li
              className={
                weekAvailability[selectedDay].fullday === "full"
                  ? "selctedtimeslot"
                  : ""
              }
              onClick={() => handleFullDayChange("full")}
            >
              Full Day
            </li>
            <li
              className={
                weekAvailability[selectedDay].fullday === "half"
                  ? "selctedtimeslot"
                  : ""
              }
              onClick={() => handleFullDayChange("half")}
            >
              Half Day
            </li>
            <li
              className={
                weekAvailability[selectedDay].fullday === ""
                  ? "selctedtimeslot"
                  : ""
              }
              onClick={() => {
                setWeekAvailability((prev) => ({
                  ...prev,
                  [selectedDay]: {
                    start: "",
                    end: "",
                    fullday: "",
                  },
                }));
              }}
            >
              Not Available
            </li>
          </div>
          <div className="Bookcaregiver_inputfield_divs">
            <div className="Bookcaregiver_inputfield">
              <label htmlFor="name">From Time</label>
              <input
                onChange={handleTimeChange}
                value={
                  weekAvailability[selectedDay].start
                    ? String(weekAvailability[selectedDay].start).padStart(
                        2,
                        "0"
                      ) + ":00"
                    : ""
                }
                placeholder="time"
                name="start"
                type="time"
                className="Bookcaregiver_input"
              />
            </div>
            <div className="Bookcaregiver_inputfield">
              <label htmlFor="name">To Time</label>
              <input
                onChange={handleTimeChange}
                value={
                  weekAvailability[selectedDay].end
                    ? String(weekAvailability[selectedDay].end).padStart(
                        2,
                        "0"
                      ) + ":00"
                    : ""
                }
                //   value={week}
                placeholder="end"
                name="end"
                type="time"
                className="Bookcaregiver_input"
              />
            </div>
          </div>
          {error !== null ? (
            <div className="validation_error" style={{ margin: "2px 0" }}>
              {error}
            </div>
          ) : null}

          <button
            className="Bookcaregiver_button"
            onClick={handlesubmit}
            disabled={load}
          >
            {load ? "Loading....." : "Update"}
          </button>
        </div>
      </div>
      {load && <Loader />}
      <KYCPopup isOpen={kyc} setisOpen={setkyc} url={url} />
      <Snackbar
        open={open}
        autoHideDuration={3000}
        onClose={() => setOpen(false)}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
      >
        <Alert variant="filled" severity="success">
          {success}
        </Alert>
      </Snackbar>
      <Snackbar
        open={open2}
        autoHideDuration={3000}
        onClose={() => setOpen2(false)}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
      >
        <Alert variant="filled" severity="error">
          {error2}
        </Alert>
      </Snackbar>
    </>
  );
};
export default Availability;
